export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14700.7c666b6c.jpg";